import Swiper from "swiper/bundle";
import "swiper/css/navigation";
import 'swiper/css/bundle';
import Splide from '@splidejs/splide';

export default {
    name: "product-compare-helper",

    setLayerParamsHeights() {

        let items = document.querySelectorAll(".js-pc-modal-item__bottom");
        let heights = [];

            items.forEach((item) => {
                let itemParams = item.querySelectorAll(
                    ".js-pc-modal-item__param"
                );
                itemParams.forEach((param, i) => {
                    param.style.height = "";
                });
            });

            items.forEach((item) => {
                let itemParams = item.querySelectorAll(
                    ".js-pc-modal-item__param"
                );
                itemParams.forEach((param, i) => {
                    if (!heights[i]) {
                        heights[i] = 0;
                    }

                    if (param.offsetHeight > heights[i]) {
                        heights[i] = param.offsetHeight;
                    }
                });
            });

            items.forEach((item) => {
                let itemParams = item.querySelectorAll(
                    ".js-pc-modal-item__param"
                );
                itemParams.forEach((param, i) => {
                    param.style.height = heights[i] + "px";
                });
            });
    },

    setLayerParamsTitles(){
        let itemBottom = document.querySelector('.js-pc-modal-item__bottom');
        let params = itemBottom.querySelectorAll('.js-pc-modal-item__param');
        let layer = document.querySelector('.js-pc-modal-layer__params');
        let layerParams = layer.querySelectorAll(".js-pc-modal-layer__param");
           
            params.forEach((el, i) => {
                layerParams[i].style.position = "absolute";
                layerParams[i].style.left = 0;
                layerParams[i].style.top = params[i].offsetTop - layerParams[i].offsetHeight + "px";
            });
    },

    setSwiper(){      
        let el = document.querySelector('.js-pc-swiper');
        
        window.PC_SWIPER = new Swiper(el, {
            slidesPerView: 2,
            speed: 300,
            spaceBetween: 8,
            navigation: {
                nextEl: ".swiper-nav__button-next-pc-swiper",
                prevEl: ".swiper-nav__button-prev-pc-swiper",
                disabledClass: "swiper-nav__disabled"
            },
            breakpoints: {
                spaceBetween: 12,
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    },
    getValue(value, compute = '', params = ''){
        
        if(compute){
            let fn = new Function(params, compute);
            return fn(value);                             
        }

        if(value && typeof value.value !== 'undefined'){
            return value['value'];
        }

        if(Array.isArray(value)){
            let string = "";

            value.forEach((v, i) => {
                string += v;

                if(i < value.length - 1){
                    string += ', ';
                }
            });

            return string;
        }

       return value;
    },
    setSlideshows(){
      /*   const productsSwiperElm = document.querySelector('.js-pc-swiper');
        var elms = productsSwiperElm.querySelectorAll('.splide');
        for (let i = 0; i < elms.length; i++) {
            if (!elms[i].classList.contains('is-active')) {
                new Splide(elms[i], { type: 'loop', perPage: 1, pagination : false }).mount();
            }
        } */
    }
};
